import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { AccountDTO } from '../../../Profile/Accounts/api/useAccountsQuery';

interface ManagementStylesDTO {
  id: number;
  name: string;
  defaultBucket: number | null;
}

interface StockOptionDTO extends AccountDTO {}

export interface StockOptionOptionsDTO {
  HasSpouse: boolean;
  OwnerOptions: {
    People: string[];
    Trusts: string[];
  };
  GrantTypeOptions: {
    label: string;
    value: number;
  }[];
  GrantYearOptions: number[];
  VestingYearOptions: number[];
  AssetClassOptions: {
    label: string;
    value: number;
  }[];
  EarmarkOptions: {
    label: string;
    value: string;
  }[];
  AllowAssetBucketingCustomization: boolean;
  AvailableAssetBuckets: {
    Title: string;
    Description: string;
    AssetTypes: number[];
  }[];
  DefaultAssetBucketIndex: number;
  AssetBucketingByManagementStyle: boolean;
  ManagementStyles: ManagementStylesDTO[];
  DisplayAssetBucketing: boolean;
}

export interface StockOptionsDTO {
  Items: StockOptionDTO[];
  Options: StockOptionOptionsDTO;
}

interface FetchParams {
  clientId: string;
}

const fetchStockOptions = async ({ clientId }: FetchParams): Promise<StockOptionsDTO> => {
  return authFetch(urlWithParams('/Consumer/StockOptions', { clientId }));
};

interface QueryParams {
  clientId: string;
}

export const useStockOptionsQuery = ({ clientId }: QueryParams) => {
  return useQuery(
    queryKeys.stockOptions(clientId),

    () => fetchStockOptions({ clientId }),

    {
      cacheTime: 0,
    },
  );
};
